// extracted by mini-css-extract-plugin
export default {"box":"box_box__8BY7b","boxContent":"box_boxContent__H4D7c","title":"box_title__hZl40","rightOfTitle":"box_rightOfTitle__QJlKG"};